import React, { useEffect, useState } from "react";
import { AlertTriangle, ShieldCheck, X } from "lucide-react";
import api from "@/lib/api";

const BANNER_STYLES = {
  pass: { bg: "bg-emerald-950/60", border: "border-emerald-800/50", icon: ShieldCheck, text: "text-emerald-300" },
  warn: { bg: "bg-amber-950/60", border: "border-amber-800/50", icon: AlertTriangle, text: "text-amber-300" },
  fail: { bg: "bg-rose-950/60", border: "border-rose-800/50", icon: AlertTriangle, text: "text-rose-300" },
};

export default function TrustBanner() {
  const [status, setStatus] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let live = true;
    const load = async () => {
      try {
        const { data } = await api.get("/trust/status");
        if (live) setStatus(data);
      } catch {}
    };
    load();
    const t = setInterval(load, 120_000);
    return () => { live = false; clearInterval(t); };
  }, []);

  if (!status || status.overall_status === "pass" || dismissed) return null;

  const style = BANNER_STYLES[status.overall_status] || BANNER_STYLES.warn;
  const Icon = style.icon;

  return (
    <div className={`flex items-center gap-3 px-4 md:px-8 py-2 text-xs border-b ${style.bg} ${style.border}`} data-testid="trust-banner">
      <Icon size={14} className={style.text} />
      <span className={`flex-1 ${style.text}`}>{status.summary}</span>
      <button onClick={() => setDismissed(true)} className="text-zinc-500 hover:text-zinc-300 transition-colors" data-testid="dismiss-trust-banner" aria-label="Dismiss">
        <X size={14} />
      </button>
    </div>
  );
}
